import React, {useRef, useEffect} from "react";
import MenuItems from "./MenuItems";
import {useDispatch, useSelector} from "react-redux";
import {switchLang} from "../../redux/actions/actions";

export default function MobileNavbar({open, setOpen, menu_items}) {
	const dispatch = useDispatch()
	
	const {location} = useSelector((state) => state.location);
	
	const sidebarRef = useRef();
	
	const handleChange = (e) => {
		dispatch(switchLang(e));
	};
	
	// close on outside click
	useEffect(() => {
		const handler = (e) => {
			if (open && sidebarRef.current && !sidebarRef.current.contains(e.target)) {
				setOpen(false);
			}
		};
		document.addEventListener("mousedown", handler);
		return () => document.removeEventListener("mousedown", handler);
	}, [open]);
	
	return (
		<>
			{/* OVERLAY */}
			{open && (
				<div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[90]"></div>
			)}
			
			{/* SIDEBAR */}
			<div
				ref={sidebarRef}
				className={`fixed top-0 left-0 h-full w-[300px] bg-[#F7F7F7] z-[99] shadow-xl transform transition-transform duration-300 overflow-y-auto
          ${open ? "translate-x-0" : "-translate-x-full"}`}
			>
				{/* HEADER */}
				<div className="flex items-center justify-between px-5 py-4 bg-[#1E242C]">
					<div className="flex items-center gap-2">
						<span className="text-xl text-white">
							<i className="ri-eye-fill"></i>
						</span>
						{/*<img src={Eye} width={22} alt="eye"/>*/}
						
						{/* Language select */}
						<select
							value={location}
							onChange={(e) => handleChange(e.target.value)}
							className="text-white font-semibold text-sm outline-none cursor-pointer bg-[#1E242C]"
						>
							<option value="uz">UZ</option>
							<option value="ru">RU</option>
						</select>
					</div>
					
					<button
						onClick={() => setOpen(false)}
						className="text-white text-2xl font-bold"
					>
						✕
					</button>
				</div>
				
				<div className="flex flex-col space-y-2 p-5 bg-white">
					<div className="flex items-center gap-3 bg-[#F7F7F7] p-4 rounded-lg">
						<div className="w-9 h-9 bg-[#464897] rounded-full flex items-center justify-center text-white">
							<i className="ri-phone-fill"></i>
						</div>
						<div className="leading-4 text-[#19213D]">
							<p className="text-sm">Единый колл-центр</p>
							<p className="font-semibold">+998 71 211 88 88</p>
						</div>
					</div>
					<div
						className="flex overflow-y-auto items-center space-x-6 p-3 rounded-lg">
						<a
							target="_blank"
							rel="noreferrer"
							href="https://unicon.uz/"
							className={`text-sm text-[#19213D] font-semibold hover:text-[#464897] hover:border-b-2 hover:border-b-[#464897] hover:font-bold`}
						>
							{
								location === "uz"
									? "Kompaniya"
									: location === "ru"
										? "Компания"
										: "Company"
							}
						</a>
						<a
							target="_blank"
							rel="noreferrer"
							href="https://dc.unicon.uz/"
							className={`text-sm text-[#19213D] font-semibold hover:text-[#464897] hover:border-b-2 hover:border-b-[#464897] hover:font-bold`}
						>
							{
								location === "uz"
									? "Data markaz"
									: location === "ru"
										? "Дата-центр"
										: "Data Center"
							}
						</a>
						<a
							target="_blank"
							rel="noreferrer"
							href="https://xizmatlar.unicon.uz/"
							className={`text-sm text-[#19213D] font-semibold hover:text-[#464897] hover:border-b-2 hover:border-b-[#464897] hover:font-bold`}
						>
							{
								location === "uz"
									? "Barcha xizmatlar"
									: location === "ru"
										? "Все услуги"
										: "All Services"
							}
						</a>
						<a
							target="_blank"
							rel="noreferrer"
							href="https://certificate.unicon.uz/"
							className={`text-sm text-[#464897] border-b-2 border-b-[#464897] font-semibold`}
						>
							{
								location === "uz"
									? "Sertifikatsiya"
									: location === "ru"
										? "Сертификация"
										: "Certification"
							}
						</a>
						<a
							target="_blank"
							rel="noreferrer"
							href="https://edu.unicon.uz/"
							className={`text-sm text-[#19213D] font-semibold hover:text-[#464897] hover:border-b-2 hover:border-b-[#464897] hover:font-bold`}
						>
							{
								location === "uz"
									? "O'quv markaz"
									: location === "ru"
										? "Учебный центр"
										: "Training Center"
							}
						</a>
						<a
							target="_blank"
							rel="noreferrer"
							href="https://stt2.unicon.uz/"
							className={`text-sm text-[#19213D] font-semibold hover:text-[#464897] hover:border-b-2 hover:border-b-[#464897] hover:font-bold`}
						>
							{
								location === "uz"
									? "Standartlar"
									: location === "ru"
										? "Стандарты"
										: "Standards"
							}
						</a>
					</div>
					<a
						target="_blank"
						rel="noreferrer"
						href="https://xizmatlar.unicon.uz/service/25"
						className="font-bold border border-[#464897] text-[#464897] px-5 py-2 rounded-md hover:bg-[#464897] hover:text-white transition">
						{
							location === "uz"
								? "Onlayn shartnoma"
								: location === "ru" ?
									"Онлайн договор" : "Online contract"
						}
					</a>
				</div>
				
				{/* MENU LIST */}
				<ul className="px-1 py-4 space-y-1">
					{menu_items?.map((menu, index) => (
						<MenuItems key={index} items={menu} depthLevel={1}/>
					))}
				</ul>
				
				{/* SOCIAL */}
				<div className="px-5 mt-6 mb-10">
					<p className="font-semibold text-xs text-[#464897] mb-2">СОЦИАЛЬНЫЕ СЕТИ</p>
					<div className="flex gap-4 text-2xl text-[#464897]">
						<a
							target="_blank"
							className="p-2 text-3xl xs:text-base px-1 rounded-full flex"
							href="https://www.instagram.com/unicon.uz_official/"
						>
							<i className="ri-instagram-line"></i>
						</a>
						<a
							target="_blank"
							className="p-2 text-3xl xs:text-base px-1 rounded-full flex"
							href="https://www.facebook.com/uniconuz"
						>
							<i className="ri-facebook-circle-fill"></i>
						</a>
						<a
							target="_blank"
							className="p-2 text-3xl xs:text-base px-1 rounded-full flex"
							href="https://t.me/uniconcompany"
						>
							<i className="ri-telegram-2-fill"></i>
						</a>
						<a
							target="_blank"
							className="p-2 text-3xl xs:text-base px-1 rounded-full flex"
							href="https://www.youtube.com/@unicon.uz_official/"
						>
							<i className="ri-youtube-fill"></i>
						</a>
					</div>
				</div>
			</div>
		</>
	);
}